module.exports = __webpack_public_path__ + "static/media/UATRE.2ee1abd7.svg";